import { render, staticRenderFns } from "./mainBlock.vue?vue&type=template&id=6853fadc&"
import script from "./mainBlock.vue?vue&type=script&lang=js&"
export * from "./mainBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports